"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useAddNewReviewees_1 = require("hooks/useAddNewReviewees/useAddNewReviewees");
const ToggledCardAccordion_1 = __importDefault(require("components/shared/ToggledCardAccordion"));
const SettingEmailNotificationReviewees = () => {
    const handleChangeState = (0, useAddNewReviewees_1.useAddNewReviewees)((state) => state.handleChangeState);
    const onChangeNotificationReviewees = (value) => {
        handleChangeState((draft) => {
            draft.payloadBody.notifyNewReviewee = value;
        });
    };
    return (react_1.default.createElement(ToggledCardAccordion_1.default, { title: "Email notification to the new reviewees", subTitle: "The new reviewees will receive email notification if this toggle is being enabled", customClass: "w-[720px]", toggleCallback: onChangeNotificationReviewees, clearContentSpace: true }));
};
exports.default = SettingEmailNotificationReviewees;
